import { type VariantProps, cva } from "class-variance-authority";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

const badge = cva(
  "inline-flex items-center rounded-[3px] px-1.5 py-0.5 text-micro font-bold",
  {
    variants: {
      tone: {
        brand: "bg-bur-l text-bur",
        neutral: "bg-line2 text-ink2",
        ok: "bg-[#E8F0EB] text-ok",
        warn: "bg-alerta-bg text-alerta-tx",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export function Badge({
  children,
  tone,
}: { children: ReactNode } & VariantProps<typeof badge>) {
  return <span className={cn(badge({ tone }))}>{children}</span>;
}
